// src/firebase.js (or similar)
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';      // Make sure this import is there
import { getFirestore } from 'firebase/firestore'; // And this for Firestore
import { getStorage } from 'firebase/storage'; // <-- Add this import
import { getAnalytics } from 'firebase/analytics'; // <-- Add this import

// Firebase config from environment (see .env.example and DEPLOYMENT.md for test vs production)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseConfig.projectId) {
  throw new Error(
    'Missing Firebase config. Copy .env.example to .env.development (test) or .env.production.local (production). See DEPLOYMENT.md.'
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // <-- Export the Storage service
export const analytics = getAnalytics(app); // <-- Export the Analytics service